<script setup lang="ts">
import { useRoute } from 'vue-router';
import { buildRedirectUrl } from '@/utils/adpDocument';

const route = useRoute();
const { docType, articleId } = route.params;
const queryString = route.fullPath.split('?')[1];

location.href = buildRedirectUrl(
  String(docType),
  String(articleId),
  queryString,
);
</script>

<template>
  <div></div>
</template>
